// src/services/channelPartnersApi.js

const API_BASE_URL = "/channel-partner";

export const getAllChannelPartners = async (axios, params = {}) => {
    try {
        const response = await axios.get(API_BASE_URL, { params });
        return response.data;
    } catch (error) {
        console.error("Error fetching all channel partners:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

export const getChannelPartnerById = async (axios, id) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/${id}`);
        return response.data;
    } catch (error) {
        console.error(`Error fetching channel partner with ID ${id}:`, error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

export const createChannelPartner = async (axios, partnerData) => {
    try {
        const response = await axios.post(API_BASE_URL, partnerData);
        return response.data;
    } catch (error) {
        console.error("Error creating channel partner:", error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

export const updateChannelPartner = async (axios, id, partnerData) => {
    try {
        const response = await axios.patch(`${API_BASE_URL}/${id}`, partnerData);
        return response.data;
    } catch (error) {
        console.error(`Error updating channel partner with ID ${id}:`, error.response?.data || error.message);
        throw error.response?.data || error;
    }
};

export const deleteChannelPartner = async (axios, id) => {
    try {
        const response = await axios.delete(`${API_BASE_URL}/${id}`);
        return response.data; // For 204 No Content, response.data might be undefined.
    } catch (error) {
        console.error(`Error deleting channel partner with ID ${id}:`, error.response?.data || error.message);
        throw error.response?.data || error;
    }
};